module.exports = __webpack_public_path__ + "fonts/intelo-bolditalic.4751197.woff";